import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getEvents } from '../api';

const categoryIcons = {
  conference: '🎤', workshop: '🛠️', concert: '🎵', 
  sports: '⚽', networking: '🤝', other: '📅'
};

const categories = ['all', 'conference', 'workshop', 'concert', 'sports', 'networking'];

function EventList() {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => { loadEvents(); }, []);

  const loadEvents = async () => {
    try {
      const { data } = await getEvents();
      setEvents(data);
    } catch (err) {
      console.error('Error loading events:', err);
    }
  };

  const filteredEvents = filter === 'all' 
    ? events 
    : events.filter(e => e.category === filter);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(price);
  };

  return (
    <div>
      <div className="hero">
        <h1>Discover Amazing Events</h1>
        <p>Browse and book tickets for conferences, concerts, workshops, and more. Find events that match your interests.</p>
      </div>

      <div className="categories">
        {categories.map(cat => (
          <button
            key={cat}
            className={`category-btn ${filter === cat ? 'active' : ''}`}
            onClick={() => setFilter(cat)}
          >
            {cat === 'all' ? '🌟 All' : `${categoryIcons[cat]} ${cat}`}
          </button>
        ))}
      </div>

      <div className="events-grid">
        {filteredEvents.map(event => {
          const availableTickets = event.capacity - (event.ticketsSold || 0);
          const soldOut = availableTickets <= 0;
          const capacityPercent = ((event.ticketsSold || 0) / event.capacity) * 100;
          
          return (
            <div key={event._id} className="event-card">
              <div className="event-image">
                <span>{categoryIcons[event.category] || '📅'}</span>
                <span className="event-category">{event.category}</span>
                {event.featured && <span className="event-featured">⭐ Featured</span>}
              </div>
              <div className="event-content">
                <h3>{event.title}</h3>
                <div className="event-meta">
                  <span>📅 {new Date(event.date).toLocaleDateString('en-IN', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
                  <span>📍 {event.location}</span>
                  {event.time && <span>🕐 {event.time}</span>}
                </div>
                <div className="event-price">
                  {formatPrice(event.price)}
                  <span className="price-label">per ticket</span>
                </div>
                <div className="event-footer">
                  <div className="event-capacity">
                    <span>{availableTickets} tickets left</span>
                    <div className="capacity-bar">
                      <div className="capacity-fill" style={{ width: `${capacityPercent}%` }}></div>
                    </div>
                  </div>
                  <Link 
                    to={`/event/${event._id}`} 
                    className={`btn ${soldOut ? 'btn-secondary' : 'btn-primary'} btn-sm`}
                  >
                    {soldOut ? 'Sold Out' : 'Book Now'}
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {filteredEvents.length === 0 && (
        <div className="empty-state">
          <span>🎭</span>
          <h3>No events found</h3>
          <p>Try a different category!</p>
        </div>
      )}
    </div>
  );
}

export default EventList;
